/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React from 'react';
import moment from 'moment';
import get from 'lodash/get';
import { Route, withRouter } from 'react-router';
import { can } from '../utils';
import AccessDenied from '../components/accessDenied';
import uiStore from '../stores/uiStore';

/*
 * Props proxy HOC that implements the repetitive logic for subpages.
 */
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Page';
}

const subPage = (route, requiredPermission = 'none', requiredOperation = 'read') => Child => {
    @withRouter
    class Component extends React.Component {
        constructor(props, context) {
            super(props, context);
            moment.locale('es');
        }

        componentDidMount() {
            window.scrollTo(0, 0);
            window.addEventListener('popstate', this.onUrlChange);
        }

        onUrlChange = () => {
            this.forceUpdate();
        };

        componentWillUnmount() {
            uiStore.unlockNavigation();
            window.removeEventListener('popstate', this.onUrlChange);
        }

        getParams = () => get(this, 'match.params');

        getParam = param => get(this, `match.params.${param}`);

        render() {
            return (
                <Route
                    path={route}
                    exact
                    render={props => {
                        this.match = props.match;

                        return (
                            <Choose>
                                <When
                                    condition={
                                        requiredPermission === 'none' || can(requiredOperation, requiredPermission)
                                    }
                                >
                                    <Child
                                        {...this.props}
                                        {...props}
                                        getParams={this.getParams}
                                        getParam={this.getParam}
                                    />
                                </When>
                                <Otherwise>
                                    <AccessDenied />
                                </Otherwise>
                            </Choose>
                        );
                    }}
                />
            );
        }
    }

    Component.displayName = `SubPage(${getDisplayName(Child)})`;

    return Component;
};

export default subPage;
